import { RolePermissionMapping } from '@traton/devportal-rbac-common-lib';
import { portalUser } from './roles';
import { agenticMarketplaceReadPermission } from './permissions';

export const roleMapping: RolePermissionMapping = new Map([
  [portalUser, [agenticMarketplaceReadPermission]],
]);
